(function () {
  function initSlider(root) {
    const list = root.querySelector(".cav-flip-cards__container");
    const prev = root.querySelector(".scrollButton_prev");
    const next = root.querySelector(".scrollButton_next");

    if (!list || !prev || !next) return;

    const items = Array.from(list.querySelectorAll(".cav-flip-card-item"));

    if (items.length === 0) return;

    let step = 0;
    let padL = 0;
    let padR = 0;

    const getMetrics = () => {
      const cs = getComputedStyle(list);
      const gap = parseFloat(cs.columnGap || cs.gap || "0");
      const w = items[0].getBoundingClientRect().width;
      step = Math.round(w + gap);
      padL = parseFloat(cs.paddingLeft) || 0;
      padR = parseFloat(cs.paddingRight) || 0;
    };

    const getMaxScrollLeft = () => list.scrollWidth - list.clientWidth;

    const getIndex = () => {
      const pos = list.scrollLeft + padL;
      return step > 0 ? Math.round(pos / step) : 0;
    };

    const clampIndex = (i) => Math.max(0, Math.min(i, items.length - 1));

    const scrollToIndex = (i) => {
      i = clampIndex(i);
      const x = i * step - padL;
      list.scrollTo({ left: x, behavior: "smooth" });
    };

    const atStart = () => list.scrollLeft <= 1;
    const atEnd = () => getMaxScrollLeft() - list.scrollLeft <= 1;

    // Check if there's any horizontal overflow
    const hasOverflow = () => list.scrollWidth > list.clientWidth;

    // Update button visibility + disabled states
    const updateButtons = () => {
      const overflow = hasOverflow();

      if (!overflow) {
        prev.classList.add("is-hidden");
        next.classList.add("is-hidden");
        return;
      }

      prev.classList.remove("is-hidden");
      next.classList.remove("is-hidden");

      const start = atStart();
      const end = atEnd();
      prev.disabled = start;
      prev.classList.toggle("is-disabled", start);
      prev.setAttribute("aria-disabled", start);
      next.disabled = end;
      next.classList.toggle("is-disabled", end);
      next.setAttribute("aria-disabled", end);
    };

    prev.addEventListener("click", () => {
      const i = getIndex();
      scrollToIndex(i - 1);
    });

    next.addEventListener("click", () => {
      const i = getIndex();
      scrollToIndex(i + 1);
    });

    list.addEventListener("scroll", updateButtons, { passive: true });

    window.addEventListener("resize", () => {
      const prevIndex = getIndex();
      getMetrics();
      scrollToIndex(prevIndex);
      requestAnimationFrame(updateButtons);
    });

    // Initial setup
    getMetrics();
    scrollToIndex(0);
    setTimeout(updateButtons, 60);
  }

  // Auto-init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(".cav-flip-cards").forEach(initSlider);
    });
  } else {
    document.querySelectorAll(".cav-flip-cards").forEach(initSlider);
  }
})();
